/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



// ===================== ANIMATION : TOP : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniProgressBarShareTopInitial = {
    // ~~~~~~~~~~~~~~~~~~~~~ INITIAL STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: '0',
        width: '100%',
        position: 'absolute',
        top: pxToEm(0),
        zIndex: '2'
    },
    // remove progess bar and share icons immediately (so they can be animated later)
    '& .progressbar.type-result, .facebook, .twitter': {
        transform: 'translateY(-300%)',
        opacity: '0'
    },
    '& .rewardsfeedback': {
        '& .icon, .text': { opacity: '0', transform: 'translateX(-300%)' }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thin]: {
        '& .resultelements': {
            fontSize: '85%'
            // top: pxToEm(18)
        }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniProgressBarShareTopInitial };